import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import Modal from "@mui/material/Modal";
import MuiAlert from "@mui/material/Alert";
import moment from 'moment'
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons'
import { Input, Button, Select, Table, message, Tooltip, Modal as AntdModal, } from 'antd';
const { Option } = Select
import { withRouter } from "react-router-dom";
import { Tour } from 'antd-v5'
const { confirm } = AntdModal;
import TranslateModal from "../common/TranslateModal";
import {
  getUserInfo,
} from "../../actions/subscribe";

import {
  getOrderList
} from "../../actions/index";
import store from "../../store";
import axios from "axios";
import { transformFile } from "babel-core";

const styles = () => {
  return {
    root: {
      width: "100%",
      height: "100%",
      padding: "10px",
      display: 'flex',
      flexDirection: 'column',
      boxSizing: "border-box"
    },
    topBar: {
      width: "100%",
      padding: "10px 20px",
      marginBottom: "10px",
      background: "#FFFFFF",
      boxShadow: "0px 1px 5px 1px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
      fontSize: '16px',
      color: '#333'
    },
    main: {
      flex: 1,
      width: "100%",
      height: "1px",
      display: 'flex',
      overflow: 'hidden'
    },
    leftTable: {
      flex: 1,
      width: '1px',
      height: "100%",
      backgroundColor: "#fff",
      boxShadow: "0px 1px 5px 1px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
      overflow: 'auto'
    },
    rightForm: {
      position: 'relative',
      width: "300px",
      height: "100%",
      marginLeft: "10px",
      backgroundColor: "#fff",
      boxShadow: "0px 1px 5px 1px rgba(0, 0, 0, 0.1)",
      borderRadius: "5px",
      transition: 'all linear .3s',
    },
    hideSearch: {
      width: 0,
      marginLeft: "0px",
      transition: 'all linear .3s'
    },
    tableOuter: {
      padding: '0 !important',
      margin: '0 !important'
    },
    topTab: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 20px'
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    total: {
      color: "#F04C35",
    },
    inputGroup: {
      marginTop: "12px",
    },
    input: {
      width: "535px",
      height: "40px",
      borderRadius: "0",
      marginRight: "20px",
      "& fieldset": {
        borderWidth: "1px !important",
      },
      "& .MuiInputBase-root": {
        borderRadius: "0",
      },
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#0F25D1 !important",
      borderRadius: "2px !important",
    },
    container: {
      padding: "16px 18px 20px 24px",
    },
    list: {
      width: "1px",
      paddingRight: "16px",
    },
    label: {
      marginBottom: "16px",
    },
    labelContainer: {
      marginTop: "40px"
    },
    btnLine: {
      display: "flex",
      justifyContent: "space-between",
    },
    titleLeft: {
      display: "flex",
      alignItems: "center",
      color: "#42BD57",
      fontSize: "18px",
      fontWeight: "bold",
      "& img": {
        width: "21px",
        height: "21px",
        marginRight: "10px",
      },
      "& button": {
        marginLeft: "20px",
        width: "82px",
        height: "32px",
        padding: "0 10px",
        borderRadius: "0",
        borderColor: "#D9D9D9",
        color: "#000",
        fontSize: "14px",
      },
    },
    subTitle: {
      margin: "20px 0 16px",
      lineHeight: "22px",
      fontSize: "16px",
      color: "#4A4A4A",
      fontWeight: "bold",
    },
    tag: {
      height: "22px",
      margin: "0 10px 16px 0",
      lineHeight: "22px",
      fontSize: "14px",
      color: "#000",
      fontWeight: "400",
      padding: "0 12px",
      display: "inline-block",
      border: "1px solid #E9E9E9",
      borderRadius: "4px",
      cursor: "pointer",
      "&.active": {
        color: "#0F25D1",
        borderColor: "#0F25D1",
      },
    },
    textBtn: {
      color: '#444',
      padding: '0 5px',
      "&:hover": {
        color: '#1890ff !important'
      }
    },
    tabTop: {
      height: "20px"
    },
    linkText: {
      color: '#333',
      '&:hover': {
        color: '#333',
        textDecoration: 'underline'
      }
    },
    slideIcon: {
      cursor: 'pointer',
    },
    select: {
      width: '100%'
    },
  };
};

class TranslateLog extends Component {
  constructor(props) {
    super(props);
    this.ref2 = React.createRef(null);
    this.ref3 = React.createRef(null);
    this.ref4 = React.createRef(null);
    this.ref5 = React.createRef(null);
  }

  state = {
    tourKey: 0,
    tourCurrent: 0,
    openTour: false,
    beginner_index: 0,
    error: "",
    search_filters: {},
    page: {
      page: 1,
      pageSize: 10,
    },
    is_all: 0,
    count: 0,
    userId: "", //用户id
    username: "", //用户名
    emptyCount: 0,
    openMessage: "",
    errorMessage: "",
    dataId: "", //弹框数据id,点击右侧管理收藏按钮时，传空
    push: true,
    openModal: false,
    isEdit: false,
    showFile: false,
    translateFile: {},
    peopelTranslateValue: false,
    modalTitle: "",
    fileTotal: 0,
    allFileList: [],
    fileList: [],
    labelList: [],
    allLabelList: [], //包含全部和无标签
    tagList: [],
    collectFileId: [],
    collectLabelId: [],
    labelArr: "", // 选中标签
    columns: [],
    loading: false,
    showTab: false,
    data: [],
    userList: [],
    tabIndex: 0,
    fileType: "",
    showSearch: true,
    tabList: [
      {
        title: '法律法规',
        type: '法律法规'
      },
      {
        title: '法规',
        type: '法规'
      },
      {
        title: '标准',
        type: '标准'
      },
      {
        title: '指导原则',
        type: '指导原则'
      },
    ],
    form: {
      userId: undefined,
      keyword: '',
    },
    paginationObj: {
      showSizeChanger: true,
      total: 0,
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    },
    scrollObj: {}
  };

  componentDidMount() {  
    let pathname = this.props.location.pathname;
    let fileType = "";
    let showTab = false
    switch (pathname) {
      case "/userCenter/translateLaw":
        fileType = "法律法规";
        showTab = true
        break;
      case "/userCenter/translateFDA":
        fileType = "海外法规";
        showTab = false
        break;
    }
    this.setState(
      {
        username: store.getState().auth.username,
        fileType: fileType,
        showTab: showTab,
      },
      () => {
        this.getColumns()
        this.queryUserInfo()
      }
    );
  }

  //查询用户信息
  queryUserInfo = () => {
    getUserInfo({ username: this.state.username }).then((res) => {
      if (res.results && res.results.length > 0) {
        let userData = res.results[0];
        if (userData) {
          let index = userData.beginner_index
          let openTour = index != 3 && index != 7
          this.setState(
            {
              userId: userData.id,
              openTour: openTour,
              beginner_index: index
            }, () => this.loadMore()
          );
        }
      }
    });
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  

  loadMore = () => {
    const param = {
      file_category: this.state.fileType,
      keyword: this.state.form.keyword,
      user_id: this.state.form.userId,
      ...this.state.page
    };
    this.setState({
      loading: true
    })
    getOrderList(param).then((res) => {
      if (res && res.result) {
        let data = res.result
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.count
        this.setState({
          data: data,
          paginationObj: newPaginationObj,
          userList: res.users_options || [],
          loading: false
        });
      } else {
        this.setState({
          loading: false
        })
      }
    });
  };

  searchFile = () => {
    this.setState(
      {
        page: 1,
      },
      () => this.loadMore(true)
    );
  };
  
  handleClose = () => {
    this.setState({
      openModal: false,
    });
  };

  showModal = (data) => {
    this.setState({
      openModal: true,
      showFile: true,
      translateFile: data
    });
  };

  peopleTranslate = (data) => {
    this.setState({
      openModal: true,
      showFile: false,
      peopelTranslateValue: true
    })
  }

  previewTranslate = (data) => {
    let file = data.translated_urls[0]
    if (!file) {
      message.warning('未找到可用的文件，请联系管理员')
      return
    }
    sessionStorage.setItem('translateFile', JSON.stringify({
      ...data,
      dfs_url: data.base_file_dfs_url,
      file_name: data.base_file_file_name
    }))
    sessionStorage.setItem('translatedFile', file.response_mono_url)
    sessionStorage.setItem('translateTwoLangFileUrl', file.response_dual_url)
    this.props.history.push('/translate')
  }


  downloadSingleFile = (data) => {
    let file = data.translated_urls[0]
    if (!file) {
      message.warning('未找到可用的文件，请联系管理员')
      return
    }
    let url = file.response_mono_url
    let baseFileName = data.base_file_file_name
    let name = baseFileName.substring(0, baseFileName.lastIndexOf('.'))
    let fileName = name + '-翻译件.pdf'
    axios({
      method: "get",
      url: url,
      responseType: "blob",
    }).then((resp) => {
      if (resp.status === 200) {
        if (window.navigator.msSaveOrOpenBlob) {
          let blob = resp.data;
          navigator.msSaveBlob(blob, fileName);
        } else {
          let blob = new Blob([resp.data], { type: "text" });
          let a = document.createElement("a");
          a.download = fileName;
          let URL = window.URL || window.webkitURL;
          a.href = URL.createObjectURL(blob);
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    });
  };

  
  resetForm = () => {
    this.setState({
      form: {
        keyword: '',
        userId: undefined
      }
    })
  }

  searchForm = () => {
    this.loadMore()
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  changeTab = (data, i) => {
    this.setState(
      {
        fileType: data.type,
        tabIndex: i,
      },
      () => {
        this.getColumns()
        this.loadMore();
      }
    );
  }

  getColumns = () => {
    let list = [
      {
        title: '翻译人',
        dataIndex: 'order_request_user',
        key: 'order_request_user',
        width: 140,
        render: (text, row) => row.order_request_user
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 320,
        align: 'center',
        render: (text, row) => {
          return (
            <>
            {
              row.order_status == '失败' &&
              <Button type="text" className={this.props.classes.textBtn} onClick={() => this.showModal(row)}>重新翻译</Button>
            }
            {
              row.order_status == '已完成' &&
              <Button type="text" className={this.props.classes.textBtn} onClick={() => this.previewTranslate(row)}>查看翻译</Button>
            }
              <Button type="text" className={this.props.classes.textBtn} onClick={() => this.peopleTranslate(row)}>人工翻译</Button>
            {
              row.order_status == '已完成' &&
              <Button className={this.props.classes.textBtn} type="text" onClick={() => this.downloadSingleFile(row)}>下载翻译件</Button>
            }
            </>
          )
        }
      },
      {
        title: '文件类型',
        dataIndex: 'base_file_file_category',
        key: 'base_file_file_category',
        width: 120,
        render: (text, row) => row.base_file_file_category
      },
      {
        title: '文件名称',
        dataIndex: 'base_file_file_name',
        key: 'base_file_file_name',
        width: 200,
        ellipsis: true,
        render: (_, row) => {
          let content = row.base_file_file_name || ''
          return   <Tooltip placement="topLeft" title={content}>
            <a target="_blank" className={this.props.classes.linkText} href={row.dfs_url}>{content}</a>
          </Tooltip>
        },
      },
      {
        title: '状态',
        dataIndex: 'order_status',
        key: 'order_status',
        width: 100,
      },
      {
        title: '翻译字符数',
        dataIndex: 'order_char_count',
        key: 'order_char_count',
        width: 140,
      },
      {
        title: '翻译时间',
        dataIndex: 'order_created_time',
        key: 'order_created_time',
        width: 160,
        render: (_, row) => {
          return moment(row.order_created_time).format('YYYY-MM-DD HH:mm')
        }
      },
      {
        title: '源语言',
        dataIndex: 'order_origin_language',
        key: 'order_origin_language',
        width: 140,
        render: (_, row) => {
          return row.order_origin_language == 'zh-cn' ? '中文' : (row.order_origin_language == 'en' ? '英文' : row.order_origin_language)
        }
      },
      {
        title: '目标语言',
        dataIndex: 'order_target_language',
        key: 'order_target_language',
        width: 140,
        render: (_, row) => {
          return row.order_target_language == 'zh-cn' ? '中文' : (row.order_target_language == 'en' ? '英文' : row.order_target_language)
        }
      },
  
      {
        title: '原文链接',
        dataIndex: 'base_file_dfs_url',
        key: 'base_file_dfs_url',
        width: 200,
        ellipsis: true,
        render: (_, row) => {
          let content = row.base_file_dfs_url || ''
          return   <Tooltip placement="topLeft" title={content}>
            <a target="_blank" href={row.base_file_dfs_url}>{content}</a>
          </Tooltip>
        },
      },
      {
        title: '翻译类型',
        dataIndex: 'order_type',
        key: 'order_type',
        width: 140,
      },
    ]
    this.setState({
      columns: list
    })
  }

  pageChange = (page, pageSize) => {
    if (page == this.state.page.page && pageSize == this.state.page.pageSize) {
      return
    }
    this.setState({
      page: {
        page: page,
        pageSize: pageSize
      },
      loading: true
    }, () => this.loadMore())
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.loadMore();
      }
    );
  };

  changeSearchShow = () => {
    this.setState({
      showSearch: !this.state.showSearch,
      tourKey: this.state.tourKey + 1
    }, () => {
      setTimeout(() => {
        this.setState({
          tourKey: this.state.tourKey + 1
        })
      }, 350)
    })
  }

  doTranslate = () => {
    
    sessionStorage.setItem('translateFile', JSON.stringify(this.state.translateFile))
    this.props.history.push('/translate')
  }
  

  render() {
    const classes = this.props.classes;


    return (
      <div className={classes.root}>
         <div className={classes.topBar}>
          翻译记录
        </div>
        <div className={classes.main}>
          <div className={classes.leftTable}>
            <div className={['common-main-container', classes.tableOuter].join(' ')}>
              <div className={['main-top', classes.topTab].join(' ')}>
                <div>
                  {
                    this.state.showTab &&
                    this.state.tabList.map((v, i) => (
                      <span
                        key={i}
                        onClick={() => this.changeTab(v, i)}
                        className={[
                          "main-tab",
                          this.state.tabIndex == i ? "active" : "",
                        ].join(" ")}
                      >
                        {v.title}
                      </span>
                    ))
                  }
                </div>
                <div className={classes.slideIcon} style={{fontSize: 20, color: '#999'}} onClick={this.changeSearchShow}  ref={this.ref5}>
                  {
                    this.state.showSearch ? 
                    <Tooltip title="收起关键词搜索">
                      <MenuUnfoldOutlined />
                    </Tooltip>
                     :
                    <Tooltip title="展开关键词搜索">
                      <MenuFoldOutlined />
                    </Tooltip>
                  }
                </div>
              </div>
              <div  className={classes.container} id="tableContainer">
                <Table 
                  className={classes.tableContainer}
                  columns={this.state.columns} 
                  loading={this.state.loading} 
                  dataSource={this.state.data} 
                  onChange={this.handleChange} 
                  pagination={this.state.paginationObj}
                  scroll={{x: 1800}}
                  bordered
                />
                
              </div>
            </div>
          </div>
          <div className={[classes.rightForm, 'common-page', this.state.showSearch ? '' : classes.hideSearch].join(' ')}>
            
            <div className="common-left-search">
              <div className="left-search-title">
                <span className="search-title">关键词搜索</span>
                
              </div>
              <div className="search-form">
                <div className="form-item">
                  <div className="form-label">关键词</div>
                  <Input  value={this.state.form.keyword}
                    allowClear
                    onChange={(e) => this.onChangeForm(e.target.value, 'keyword')} 
                    placeholder="请输入关键词"/>
                </div>
                <div className="form-item">
                  <div className="form-label">翻译人</div>
                  <Select
                    allowClear
                    className={classes.select}
                    placeholder="请选择"
                    value={this.state.form.userId}
                    onChange={(e) => this.onChangeForm(e, 'userId')} 
                  >
                    {
                      this.state.userList.map((v, i) => {
                        return (
                          <Option value={v.user_id} key={i}>{v.user_name}</Option>
                        )
                      })
                    }
                  </Select>
                </div>

               
              </div>

              <div className="search-bottom-btns">
                <Button className="default-btn" onClick={this.resetForm}>重置</Button>
                <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
              </div>
            </div>
          </div>
        </div>
        
        <TranslateModal
          openModal={this.state.openModal}
          handleClose={this.handleClose}
          showFile={this.state.showFile}
          translateFile={this.state.translateFile}
          peopelTranslateValue={this.state.peopelTranslateValue}
          doTranslate={this.doTranslate}
          backTranslate={this.handleClose}
        ></TranslateModal>

      </div>
    );
  }
}

export default withStyles(styles)(withRouter(TranslateLog));
